import axios from "axios";
import Config from "../config";
import RefreshTokenHandler from "../refreshToken/refreshToken";

export const getPatientCaseData = async (
  email,
  patient_id,
  page_size,
  page_number
) => {
  try {
    const token = sessionStorage.getItem("token");
    const url = `${Config.baseUrl}/case/patient-case-data?email=${email}&patient_id=${patient_id}&page_size=${page_size}&page_number=${page_number}`;
    const result = await axios.get(url, {
      headers: {
        Authorization: token || "",
      },
    });
    return result;
  } catch (err) {
    if (err.response.data.status == 401 || err.response.status == 403) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getPatientCaseData(
          email,
          patient_id,
          page_size,
          page_number
        );
      } else {
        throw err;
      }
    } else {
      throw err;
    }
  }
};

export const getPatientbyID = async (email, patient_id) => {
  try {
    const token = sessionStorage.getItem("token");
    const url = `${Config.baseUrl}/patient/by-id?email=${email}&patient_id=${patient_id}`;
    const result = await axios.get(url, {
      headers: {
        Authorization: token || "",
      },
    });
    return result;
  } catch (err) {
    if (err.response.data.status == 401 || err.response.status == 403) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getPatientbyID(email, patient_id);
      } else {
        throw err;
      }
    } else {
      throw err;
    }
  }
};

export const updatePatientPictures = async (data) => {
  try {
    const token = sessionStorage.getItem("token");
    const url = `${Config.baseUrl}/patient/patient-pictures`;
    const formData = new FormData();
    let keys = Object.keys(data);
    for (let i = 0; i < keys.length; i++) {
      let temp = keys[i];

      if (
        typeof data[temp] == "object" &&
        temp !== "lateral" &&
        temp !== "left_picture" &&
        temp !== "occlusal_lower" &&
        temp !== "occlusal_upper" &&
        temp !== "lateral" &&
        temp !== "panoramic" &&
        temp !== "patient_profile_picture" &&
        temp !== "smily_picture" &&
        temp !== "composite_picture" &&
        temp !== "front_picture" &&
        temp !== "right_picture" &&
        temp !== "front_teeth_picture" &&
        temp !== "buccal_left_picture" &&
        temp !== "buccal_right_picture" &&
        temp !== "file_link" &&
        temp !== "file_link_upper" &&
        temp !== "file_link_lower" &&
        temp !== "ipr_chart"
      ) {
        formData.append(temp, JSON.stringify(data[temp]));
      } else {
        formData.append(temp, data[temp]);
      }
    }

    const result = await axios.post(url, formData, {
      headers: {
        Authorization: token || "",
      },
    });
    return result;
  } catch (err) {
    if (err.response.data.status == 401 || err.response.status == 403) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await updatePatientPictures(data);
      } else {
        throw err;
      }
    } else {
      return err.response;
    }
  }
};

export const updatePatient = async (data) => {
  try {
    const token = sessionStorage.getItem("token");
    const url = `${Config.baseUrl}/patient/${data.patient_id}`;
    const formData = new FormData();
    let keys = Object.keys(data);
    for (let i = 0; i < keys.length; i++) {
      let temp = keys[i];
      if (typeof data[temp] == "object" && temp != "profile_picture") {
        formData.append(temp, JSON.stringify(data[temp]));
      } else {
        formData.append(temp, data[temp]);
      }
    }

    const result = await axios.put(url, formData, {
      headers: {
        Authorization: token || "",
      },
    });
    return result;
  } catch (err) {
    if (err.response.data.status == 401 || err.response.status == 403) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await updatePatient(data);
      } else {
        throw err;
      }
    } else {
      throw err;
    }
  }
};
